var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7096 13.166L68.9676 13.166L68.9798 13.166C71.0157 13.1756 72.9656 14.0242 74.4052 15.5274C75.8448 17.0306 76.6576 19.0667 76.6667 21.1925L76.6667 21.2053V62.4607L76.6667 62.4735C76.6576 64.5993 75.8448 66.6354 74.4052 68.1386C72.9656 69.6418 71.0157 70.4905 68.9798 70.5L68.9676 70.5H26.711C25.6144 70.4995 24.5306 70.254 23.5324 69.78C22.5341 69.306 21.6446 68.6143 20.9236 67.7516C20.8158 67.6226 20.7199 67.4847 20.6367 67.3395L5.45606 43.4164C4.84707 42.4567 4.847 41.2097 5.45588 40.2499L20.705 16.2126C20.7728 16.1057 20.8474 16.0036 20.9284 15.9071C21.6497 15.047 22.5386 14.3576 23.5356 13.8849C24.5325 13.4121 25.6146 13.1671 26.7096 13.166ZM26.7137 18.8994C26.4005 18.8999 26.0909 18.97 25.8058 19.1053C25.5652 19.2193 25.3467 19.3774 25.1603 19.5717L11.0379 41.8328L25.17 64.1035C25.354 64.2937 25.5691 64.4487 25.8055 64.561C26.0906 64.6964 26.4001 64.7665 26.7132 64.7666H68.96C69.5464 64.7626 70.1079 64.5175 70.5226 64.0844C70.9374 63.6514 71.172 63.0652 71.1759 62.4528V21.2132C71.172 20.6008 70.9374 20.0147 70.5226 19.5816C70.1079 19.1485 69.5466 18.9035 68.9602 18.8994H26.7137Z",
    fill: "#C84B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.504 28.3287C62.6097 29.4344 62.6097 31.2269 61.504 32.3326L38.4993 55.3373C37.3937 56.4429 35.6011 56.4429 34.4955 55.3373C33.3899 54.2317 33.3899 52.4391 34.4955 51.3335L57.5002 28.3287C58.6058 27.2231 60.3984 27.2231 61.504 28.3287Z",
    fill: "#C84B31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4955 28.3287C35.6011 27.2231 37.3937 27.2231 38.4993 28.3287L61.504 51.3335C62.6097 52.4391 62.6097 54.2317 61.504 55.3373C60.3984 56.4429 58.6058 56.4429 57.5002 55.3373L34.4955 32.3326C33.3899 31.2269 33.3899 29.4344 34.4955 28.3287Z",
    fill: "#C84B31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.7fcc828af249f0ed7a96777c9b809629.svg";
export { ForwardRef as ReactComponent };